export default function (link) {
    const query = {};

    if (link.type == "verbb\\hyper\\links\\Email") return "mailto:" + link.linkUrl;
    if (link.type == "verbb\\hyper\\links\\Phone") return "tel:" + link.linkUrl;


    if (['verbb\\hyper\\links\\Entry', 'verbb\\hyper\\links\\Category'].includes(link.type) &&
        (link.customAttributes != undefined && !!Object.keys(link.customAttributes).length)) {
        for (const [key, value] of Object.entries(link.customAttributes)) {
            query[key] = value;
        }
    }

    if (link.type == "verbb\\hyper\\links\\Entry")
        return {
            "home": {
                name: "index",
                query: query
            },
            "setUpMaintenance": {
                name: "set-up-maintenance",
                query: query
            },
            "pages": {
                name: "slug",
                params: {
                    slug: link.element.slug
                },
                query: query
            },
            "products": {
                name: "products-slug",
                params: {
                    slug: link.element.slug
                },
                query: query
            },
            "community": {
                name: "community-slug",
                params: {
                    slug: link.element.slug
                },
                query: query
            }
        }[link.element.sectionHandle];


    if (link.type == "verbb\\hyper\\links\\Category")
        return {
            "types": {
                name: "products-type-slug",
                params: {
                    slug: link.element.slug
                },
                query: query
            }
        }[link.element.groupHandle];

    return link.linkUrl;
}
